
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aviso-legal",
      function () {
        return require("private-next-pages/aviso-legal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aviso-legal"])
      });
    }
  